import React, { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import AddProposal from '../../Portals/Proposals/AddProposal'
import HospitalView from '../HospitalViewProfile/HospitalView'
import HospitalProfile from '../HospitalViewProfile/hospitalProfile/hospitalProfile'
import HospitalPreview from '../HospitalViewProfile/hospitalPreview/HospitalPreview'
import ViewPost from '../ContentMarketing/ViewPost'
import ViewDetails from '../../Portals/posts/ViewDetails'
import ViewPostDetails from '../ContentMarketing/ViewPostDetails'
import CompanyView from '../CompanyViewProfile/CompanyView'
import CompanyProfile from '../CompanyViewProfile/CompanyProfile/CompanyProfile'
import EmailMarketing from '../EmailMarketing/EmailMarketing'
import CreateContent from '../EmailMarketing/CreateContent'
import PrintAd from '../PrintAd/PrintAd'
import ViewPrintAd from '../PrintAd/ViewPrintAd'
import AddPrints from '../PrintAd/AddPrints'
import BannerAddTable from '../bannerAds/BannerAddTable'
import Newsletter from '../Newsletters/Newsletter'
import AddNewsletter from '../Newsletters/AddNewsletter'
import ViewNewsletter from '../Newsletters/ViewNewsletter'
import AddBannerAds from '../bannerAds/AddBannerAds'
import ViewBannerAd from '../bannerAds/ViewBannerAd'
import EmaiMarketViewData from '../EmailMarketing/EmaiMarketViewData'
import EventListing from '../eventListing/EventListing'
import ViewDetailsEvents from '../../Portals/posts/ViewDetailsEvents'


function DashboardModule() {
  return (
    <div className='w-full'>
       <Suspense fallback={null}>
       <Routes>
        <Route path="HospitalViewProfile" element={<HospitalView  />} />
        <Route path="/HospitalViewProfile/hospitalProfile" element={<HospitalProfile  />} />
        <Route path="CompanyViewProfile" element={< CompanyView />} />
        <Route path="/companyViewProfile/companyProfile" element={<CompanyProfile  />} />
        <Route path="/contentMarketing" element={<ViewPost  />} />
        <Route path='/contentMarketing/viewPost' element={<ViewPostDetails />} />
        <Route path='/emailMarketing' element={<EmailMarketing />} />
        <Route path='/emailMarketing/createContent' element={<CreateContent />} />
        <Route path='/emailMarketing/viewData' element={<EmaiMarketViewData />} />
        <Route path="/printAd" element={<PrintAd  />} />
        <Route path="/printAd/ViewPrintAd" element={<ViewPrintAd />} />
        <Route path="/printAd/addBanner" element={<AddPrints />} />
        <Route path="/bannerAds" element={<BannerAddTable />} />
        <Route path="/bannerAds/viewBannerads" element={<ViewBannerAd />} />
        <Route path="/bannerAds/addBanner" element={<AddBannerAds />} />
        <Route path="/newsletter" element={<Newsletter />} />
        <Route path="/newsletter/addNewsletter" element={<AddNewsletter />} />
        <Route path="/newsletter/viewNewsletter" element={<ViewNewsletter />} />
        <Route path="/eventListing" element={<EventListing />} />
        <Route path="/eventListing/viewDetailsEvents" element={<ViewDetailsEvents />} />
      </Routes>
    </Suspense>
    </div>
  )
}

export default DashboardModule
